import { render, staticRenderFns } from "./TypeRestrictionForm.vue?vue&type=template&id=389dcba2&"
import script from "./TypeRestrictionForm.vue?vue&type=script&lang=js&"
export * from "./TypeRestrictionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports